// extracted by mini-css-extract-plugin
export default {"button":"TextButton_button__kdPII","normal":"TextButton_normal__KlvaP","disable":"TextButton_disable__cXWNr","right":"TextButton_right__EXB6w","wrong":"TextButton_wrong__qjZ0C"};